import React from 'react';
import LoaderGIF from '../images/JioLoader.svg';

export default props => (
  <>
    {props.loadingCount > 0 && (
      <div style={{
        position: 'fixed',
        zIndex: '1000',
        top: '35%',
        left: '50%',
        transform: 'translate(-50%, 0)'
      }}
      >
        <img
          style={{
            width: '80px',
            height: '80px'
          }}
          src={LoaderGIF}
          alt=""
        />
      </div>
    )}
  </>
);
